import React, { useState } from "react";
import styles from './ReportFilterTrips.module.scss';
import { Badge, Button, Card, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { t } from "i18next";
import Lottie from "react-lottie";
import reportTicket from "../../../assets/animation/animation_report";
import DatePicker from "react-datepicker";
import it from 'date-fns/locale/it';

//general
import UserClass from "../../../General/LocalStorage/UserClass";
import DataManager from "../../../General/DataManager";
import Functions from "../../../General/Functions";
import Select, {
    components,
    GroupTypeBase,
    MultiValueProps
} from "react-select";
import makeAnimated from 'react-select/animated';



const ReportTicketSummary = props => {
    const defaultOptionsReport = {
        loop: true,
        autoplay: true,
        animationData: reportTicket
    };
    const [showModalFilter, setShowModalFilter] = useState(false);
    const [totFilter, setTotFilter] = useState(0);
    const [showModalFilterTrips, setshowModalFilterTrips] = useState(false);
    const [msgModalReport, setMsgModalReport] = useState("");
    //const [pdfChecked, setpdfChecked] = useState(true);
    const [csvChecked, setcsvChecked] = useState(true);
    const [dateFrom, setDateFrom] = useState(null);
    const [showEndDate, setshowEndDate] = useState(true)
    const [endDate, setEndDate] = useState(null);
    const [showCompany, setshowCompany] = useState(true)
    const [company, setCompany] = useState("");
    const [companies, setCompanies] = useState([])
    const [disableButton, setDisableButton] = useState(true)
    const [typologyReport, setTypologyReport] = useState("");
    const [dateOfDay, setDateOfDay] = useState("");
    const [dateOfMonth, setDateOfMonth] = useState(null);
    const [reset, setReset] = useState(false);
    const [showDocument, setshowDocument] = useState(true);
    const [Document, setDocument] = useState(null);
    const [showTrip, setShowTrip] = useState(true);
    const [Trips, setTrips] = useState([])
    const [tripItem, setTripItem] = useState([])
    const [showSpinner, setShowSpinner] = useState(true)
    const [selectedCompaniesBox, setSelectedCompaniesBox] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState('DEPARTUREDATE');





    React.useEffect(() => {

        getCompanies();

    }, []);

    const actionApply = () => {

        let tot = 0;
        setTotFilter(tot);

        if (typeof (company) !== 'undefined' && company !== null && company !== "" && typeof (dateFrom) !== 'undefined' && endDate >= dateFrom && dateFrom !== null && endDate !== null && typeof (endDate) !== 'undefined') {
            setShowModalFilter(false)
            setshowModalFilterTrips(true)
            setDocument(null)

            let modeFile = "csv";
            /*if (csvChecked == true) {
                modeFile = "csv";
            }*/
            let instance = UserClass.getInstance();

            let token = instance.getTokenUser();
            let date_from = dateFrom;
            let date_to = endDate;

            DataManager.getReportTicketSummary(token, company, date_from, date_to, modeFile, selectedFilter).then((result) => {

                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['report']) !== 'undefined' && result['report'] !== null) {
                        if (modeFile.toString() === "csv") {
                            const url = window.URL.createObjectURL(new Blob([result['report']]))
                            const link = document.createElement('a')
                            link.href = url;
                            const fileName = `report.csv`;
                            link.setAttribute('download', fileName);
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            setshowModalFilterTrips(false)
                        } else {
                            let blob = new Blob([result['report']], {
                                type: "application/pdf"
                            });
                            const url = window.URL.createObjectURL(blob);
                            setDocument(url);
                            setshowDocument(false);
                            setshowModalFilterTrips(false)
                        }

                    } else {
                        setshowModalFilterTrips(false);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    setshowModalFilterTrips(false);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            })



            if (company !== "") {
                tot = tot + 1;

            }
            if (csvChecked /*|| pdfChecked*/) {
                tot = tot + 1;
            }

            if (dateFrom != "") {
                tot = tot + 1;
            }
            if (endDate != "") {
                tot = tot + 1;
            }

            if (selectedFilter) {
                tot = tot + 1;
            }



            setTotFilter(tot)
        }
        else {

            if (endDate < dateFrom) {

                Functions.alertMsg(t("error_date"));
            }
            else {
                Functions.alertMsg("Company Field is required");

            }

        }
    };
    const getCompanies = () => {
        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();


        DataManager.verifyLogin
            (token).then((result) => {
                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['verifylogin']) !== 'undefined' && result['verifylogin'] !== null) {

                        setCompanies(result['verifylogin']['companies'])
                    } else {
                        //setshowModalFilterRaceSummary(false);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }
                } else {
                    //setshowModalFilterRaceSummary(false);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            });
    }
    const actionSelectFilter = () => {
        setShowModalFilter(!showModalFilter);
    };
    /*const setTypeCompany = (e) => {
        let selectedIndex = e.target.selectedIndex;
        let selectedOption = e.target.options[selectedIndex];
        let selectedValue = selectedOption.value;

        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {
                setCompany(companies[e.target.selectedIndex - 1]);
                setShowSpinner(false)
                getTrips(companies[e.target.selectedIndex - 1]);

            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();

    };*/
    const setTypeCompany = (e) => {
        setShowTrip(true)


        if (e?.length > 0) {




            setTimeout(() => {
                setSelectedCompaniesBox(e);
                setCompany(e.map((item) => item.value).join(","));
                getTicketSummary(e.map((item) => item.value).join(","), dateFrom, endDate);
                //setShowSpinner(false)
                //getTrips( e.map((item)=>item.value ).join(","),dateFrom,endDate);

            }, 300);
        }
        else {
            setDisableButton(true);
            setSelectedCompaniesBox(null);
            setShowTrip(true)

        }


    };
    const renderOption2 = (obj, idx) => {
        let check = false;
        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            if (company.toString() === obj) {
                check = true;
            }
        }
        return <option selected={check} key={idx}>{t(obj)}</option>
    };
    const handleChange = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };
    const actionReset = () => {
        setReset(true);
        setCompany("")
        setDateFrom("")
        //setpdfChecked(true)
        setcsvChecked(true)
        setshowCompany(true)
        setshowEndDate(true)
        setEndDate(null)
        setDisableButton(true)
        setshowDocument(true);
        setTotFilter(0)
        setShowTrip(true)
        setSelectedCompaniesBox(null);
        setSelectedFilter('DEPARTUREDATE');



    };
    const renderTrip = (obj, idx) => {


        let check = false;
        if (typeof (tripItem) !== 'undefined' && tripItem !== null && tripItem !== "") {
            if (tripItem === obj) {
                check = true;
            }
        }

        return <option selected={check} key={idx}>{obj.departurePort + '-' + obj.destinationPort}</option>





    };

    const setTypeRoute = (e) => {


        if (typeof (e.target.selectedIndex) !== 'undefined' && e.target.selectedIndex !== null) {
            setTimeout(() => {
                if (Trips[e.target.selectedIndex - 1] !== "" && Trips[e.target.selectedIndex - 1] !== undefined) {
                    setTripItem(Trips[e.target.selectedIndex - 1]);

                    setDisableButton(false);
                }
                else {
                    setDisableButton(true);

                }

            }, 300);
        }
        e.preventDefault();
        e.stopPropagation();
    };

    const getTicketSummary = (company, dateFrom, endDate) => {

        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();
        let route = true;
        let from_date = dateFrom;
        let to_date = endDate;

        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            setDisableButton(false);
        }
        else {
            setShowSpinner(true)
            setDisableButton(true);

        }




    }
    const getTrips = (company, dateFrom, endDate) => {


        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();
        let route = true;
        let from_date = dateFrom;
        let to_date = endDate;

        if (typeof (company) !== 'undefined' && company !== null && company !== "") {
            DataManager.getTripsRoute(token, company, route, from_date, to_date).then((result) => {

                if (typeof (result) !== 'undefined' && result !== null) {
                    if (typeof (result['trips']['results']) !== 'undefined' && result['trips']['results'] !== null) {

                        setTrips(result['trips']['results']);
                        //setTrips(result['trips']['results'].filter(item => item.active === true))
                        setShowTrip(false)
                        setShowSpinner(true)

                    }
                    else {
                        setshowModalFilterTrips(true);
                        if (typeof (result['msgError']) !== 'undefined' && result['msgError'] !== null && result['msgError'] !== "") {
                            Functions.alertMsg(result['msgError']);
                        } else {
                            Functions.alertMsg(t("msgErrorGeneral"));
                        }
                    }

                }
                else {
                    setshowModalFilterTrips(true);
                    Functions.alertMsg(t("msgErrorGeneral"));
                }
            });
        }
        else {
            setShowSpinner(true)
            setShowTrip(true)

        }



    }

    const CustomMultiValue = (props) => (
        <components.MultiValue {...props}>
            {props.data.label}
        </components.MultiValue>
    );

    const options = companies.map((item) => ({
        value: item.toString(),
        label: `${item.toString()}`
    }));

    const animatedComponents = makeAnimated({
        MultiValue: CustomMultiValue
    });

    const handleDateFrom = (e) => {

        e.persist();
        setDateFrom(e.target.value);
        if (company !== "" && typeof company !== 'undefined' && !showCompany) {
            //setShowTrip(true);
            //setShowSpinner(false);
            setDisableButton(true);
            //getTicketSummary(company, e.target.value, endDate);

        }
        else {
            setshowEndDate(false);
        }
    }
    const handleEndDate = (e) => {

        console.log((new Date(e.target.value).getMonth() - new Date(dateFrom).getMonth()) === 1 ? (new Date(dateFrom).getDate() === new Date(e.target.value).getDate()) : "")
        e.persist();
        setEndDate(e.target.value);
        if (company !== "" && typeof company !== 'undefined' && !showCompany) {
            //setShowTrip(true);
            setDisableButton(true);
            //setShowSpinner(false);
            //getTicketSummary(company, dateFrom, e.target.value);
        }
        else {
            setshowCompany(false);
        }
    }

    return (
        <div className={styles.ReportFilterTrips}>
            <Button
                className="mb-3 ml-10"
                onClick={actionSelectFilter}
                title={t("filters")}
            >
                <i className="fa-solid fa-filter side-menu__icon" /> {t("filters")} {totFilter > 0 ? <Badge bg="secondary">{totFilter.toString()}</Badge> : null}
            </Button>
            <Modal
                {...props}
                size="xs"
                show={showModalFilterTrips}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>{msgModalReport}</Modal.Body>
                <Lottie options={defaultOptionsReport}
                    height={200} />
            </Modal>
            <Modal show={showModalFilter}>
                <Modal.Header>
                    <Modal.Title>{t("filters")}</Modal.Title>
                    <Button onClick={actionSelectFilter}><i className="fa-solid fa-xmark" /></Button>
                </Modal.Header>
                <Modal.Body style={{
                    maxHeight: 'calc(100vh - 210px)',
                    overflowY: 'auto'
                }}>
                    <Form>
                        <Form.Label>{t("file_format")}</Form.Label>
                        <Row>
                            {/*<Col xl={6}>
                                <Form.Group className="mb-3">

                                    <div className="mb-3">
                                        <Form.Check
                                            value="daily"
                                            type="radio"
                                            aria-label="radio 1"
                                            label={"PDF"}
                                            checked={pdfChecked}

                                            onChange={(e) => {
                                                setpdfChecked(true);
                                                setcsvChecked(false);

                                            }}
                                        />

                                    </div>
                                </Form.Group>
                            </Col>*/}
                            <Col xl={6}>
                                <Form.Group className="mb-3">
                                    <div className="mb-3">
                                        <Form.Check
                                            value="monthly"
                                            type="radio"
                                            aria-label="radio 2"
                                            label={"CSV"}
                                            checked={csvChecked}
                                            onChange={(e) => {
                                                //setpdfChecked(false);
                                                setcsvChecked(true);

                                            }}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                        <>
                            <Form.Label>{t("select_filter_type")}</Form.Label>
                            <Row>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("departure_date")}
                                            value="DEPARTUREDATE"
                                            checked={selectedFilter === 'DEPARTUREDATE'}
                                            onChange={() => setSelectedFilter('DEPARTUREDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("issue_date")}
                                            value="ISSUEDATE"
                                            checked={selectedFilter === 'ISSUEDATE'}
                                            onChange={() => setSelectedFilter('ISSUEDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xl={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="radio"
                                            label={t("boarding_date")}
                                            value="BOARDINGDATE"
                                            checked={selectedFilter === 'BOARDINGDATE'}
                                            onChange={() => setSelectedFilter('BOARDINGDATE')}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>
                        <Row>
                            <Col xl={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("select_start_date")}</Form.Label>
                                    <Form.Control onChange={(e) => {

                                        handleDateFrom(e);
                                    }} type="date" value={dateFrom !== "" ? dateFrom : ""} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row hidden={showEndDate}>
                            <Col xl={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("select_end_date")}</Form.Label>
                                    <Form.Control onChange={(e) => {
                                        handleEndDate(e);
                                    }} type="date" value={endDate !== "" ? endDate : ""} min={dateFrom !== "" ? new Date(dateFrom).toISOString().split("T")[0] : null} max={dateFrom !== "" ? new Date(new Date(dateFrom).setMonth(new Date(dateFrom).getMonth() + 1)).toISOString().split("T")[0] : ""} />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/*<Row hidden={showCompany}>
                            <Col xl={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("company")}</Form.Label>
                                    <Form.Select size="lg" onChange={(e) => setTypeCompany(e)}>
                                        <option key="value_null">-- {t("select")} --</option>
                                        {companies.map((item, idx) => (
                                            renderOption2(item, idx)
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>*/}


                        <Row hidden={showCompany}>
                            <Col xl={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("company")}</Form.Label>
                                    <Select
                                        label="Companies"
                                        isMulti
                                        options={options}
                                        components={animatedComponents}
                                        onChange={(e) => { setTypeCompany(e) }}
                                        value={selectedCompaniesBox !== null ? selectedCompaniesBox : null}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Spinner hidden={showSpinner} animation="border" size="sm" />

                        {/*<Row hidden={showTrip} >
                            <Col xl={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("itinerary")}</Form.Label>
                                    <Form.Select size="lg" onChange={(e) => setTypeRoute(e)} className={styles.wrapper}>
                                        <option key="value_null">-- {t("select")} --</option>
                                        {Trips.map((item, idx) => (
                                            renderTrip(item, idx)
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>*/}

                    </Form>
                </Modal.Body>
                {
                    typologyReport === "daily" ?
                        <Form style={{
                            marginLeft: '15px',
                            marginBottom: '10px',
                            marginTop: '-10px'
                        }}>
                            <Row>
                                <Col xl={12}>
                                    <Form.Group className="mb-3">
                                        <p>{t("select_start_date")}</p>
                                        <Form.Control style={{ width: "50%" }} onChange={(e) => {
                                            handleChange(e);
                                            setDateOfDay(e.target.value);
                                        }} type="date" value={dateOfDay !== "" ? dateOfDay : ""} />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                        : null
                }
                {
                    typologyReport === "monthly" ?
                        <Form style={{
                            marginLeft: '15px',
                            marginBottom: '10px',
                            marginTop: '-10px'
                        }}>
                            <Row>
                                <Col xl={12}>
                                    <p>{t("select_month_year")}</p>
                                    <DatePicker locale={it}
                                        selected={dateOfMonth === null ? new Date() : dateOfMonth}
                                        onChange={(date) => setDateOfMonth(date)}
                                        dateFormat="MM/yyyy"
                                        showMonthYearPicker
                                        showFullMonthYearPicker
                                        showTwoColumnMonthYearPicker />
                                </Col>
                            </Row>
                        </Form>
                        : null
                }
                <Modal.Footer>
                    <Button variant="secondary" onClick={actionReset}>
                        {t("reset")}
                    </Button>
                    <Button disabled={disableButton} variant="primary" onClick={actionApply}>
                        {t("apply")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Row hidden={showDocument}>

                {

                    Document !== null ?
                        (

                            <Col xl={12}>
                                <div className="pb-70">
                                    <Card>
                                        <Card.Body>
                                            <object width="100%" height="600"
                                                data={Document}
                                                type="application/pdf"></object>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>


                        )
                        : null
                }
            </Row>
        </div>
    )

};

export default ReportTicketSummary;
